import React from 'react';
import * as QuickSightEmbedding from 'amazon-quicksight-embedding-sdk';
import generateQuicksightUrl from './apis';
import { Alert, SpaceBetween, Spinner, BreadcrumbGroup, Container, Header } from '@amzn/awsui-components-console';

class QuickSightController extends React.Component {
    /**
     * quicksight dashboard controller component
     * @param props
     */
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            shouldAlert: false,
        };
    }

    componentDidMount = () => {
        this.loadQuickSightDashboard();
    };

    loadQuickSightDashboard = async () => {
        // change loading state to true
        this.onDashboardLoading();

        try {
            const response = await generateQuicksightUrl();
            const dashboardURL = response['url'];
            const options = {
                url: dashboardURL,
                scrolling: 'auto',
                height: 'AutoFit',
                width: '100%',
                loadingHeight: '100%',
                container: document.getElementById('dashboardContainer'),
            };
            const dashboard = QuickSightEmbedding.embedDashboard(options);
            // change loading state to false
            this.onDashboardLoadSuccess();
            dashboard.on('error', this.onDashboardLoadFailure);
            dashboard.on('load', this.onDashboardLoadSuccess);
        } catch (e) {
            console.error(e);
            // change shouldAlert state to true
            this.onDashboardLoadFailure();
        }
    };

    onDashboardLoading = () => {
        this.setState({
            shouldAlert: false,
            loading: true,
        });
    };

    onDashboardLoadSuccess = () => {
        this.setState({
            shouldAlert: false,
            loading: false,
        });
    };
    onDashboardLoadFailure = () => {
        this.setState({
            shouldAlert: true,
            loading: false,
        });
    };

    render() {
        let spinner = this.state.loading && <Spinner size="large" />;
        let alert = this.state.shouldAlert && (
            <Alert
                dismissAriaLabel="Close alert"
                type="error"
                header="Failed to Load analytics dashboard, please reload the page and try again!"
            />
        );
        return (
            <SpaceBetween size="s">
                <BreadcrumbGroup
                    items={[
                        { text: 'Amazon Device Farm', href: '#/' },
                        {
                            text: 'Analytics',
                            href: '#/metrics/analytics',
                        },
                    ]}
                />
                <Container
                    header={
                        <Header variant="h2" description="">
                            Device Farm metrics analytics
                        </Header>
                    }
                >
                    <div className="awsui-util-container awsui-util-no-gutters">
                        {spinner}
                        {alert}
                        <div className="quicksight-container">
                            <div id="dashboardContainer" />
                        </div>
                    </div>
                </Container>
            </SpaceBetween>
        );
    }
}

export default QuickSightController;
